import Badge from './Badge';
import Button from './Button';
import StatusDot from './StatusDot';

export default function IntegrationCard({
  name,
  provider,
  status,
  lastValidated,
  scopes = [],
  onConfigure,
  onValidate,
  onSync,
  syncStatus,
}) {
  const statusMap = {
    connected: { label: 'Conectado', variant: 'success', dot: 'success' },
    disconnected: { label: 'Desconectado', variant: 'neutral', dot: 'neutral' },
    error: { label: 'Error', variant: 'danger', dot: 'danger' },
    pending: { label: 'Pendiente', variant: 'warning', dot: 'warning' },
  };

  const info = statusMap[status] || statusMap.disconnected;

  return (
    <div className="aui-integration-card">
      <div className="header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <StatusDot status={info.dot} />
          <span className="name">{name}</span>
        </div>
        <Badge variant={info.variant}>{info.label}</Badge>
      </div>
      {provider && <div className="meta">Proveedor: {provider}</div>}
      {lastValidated && <div className="meta">Última validación: {lastValidated}</div>}
      {scopes.length > 0 && (
        <div className="meta" style={{ display: 'flex', gap: '0.35rem', flexWrap: 'wrap' }}>
          {scopes.map((s) => (
            <Badge key={s} variant="info">{s}</Badge>
          ))}
        </div>
      )}
      {syncStatus && (
        <div className="meta">
          Sync Weltas:{' '}
          <Badge variant={syncStatus === 'synced' ? 'success' : syncStatus === 'pending' ? 'warning' : 'neutral'}>
            {syncStatus === 'synced' ? 'Sincronizado' : syncStatus === 'pending' ? 'Pendiente' : 'No sincronizado'}
          </Badge>
        </div>
      )}
      <div className="actions">
        {onConfigure && <Button variant="secondary" onClick={onConfigure}>Configurar</Button>}
        {onValidate && <Button variant="secondary" onClick={onValidate}>Validar</Button>}
        {onSync && <Button variant="ghost" onClick={onSync}>Sincronizar</Button>}
      </div>
    </div>
  );
}
